// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__7e938831","heading":"heading__7e938831","close":"close__7e938831","info":"info__7e938831","row":"row__7e938831","code":"code__7e938831","label":"label__7e938831"};